// HACKATHON: Add news hook to useMarketData_v2.js
// Add this to your existing file or create new one

import { useState, useEffect } from 'react';

const API_BASE_PYTHON = '/api/py82/api';

// Generic fetch for Python API
export const usePythonAPIData = (endpoint, interval = 30000) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`${API_BASE_PYTHON}${endpoint}`);
        const json = await res.json();
        setData(json);
        setLoading(false);
      } catch (err) {
        console.error(`Error fetching ${endpoint}:`, err);
        setLoading(false);
      }
    };

    fetchData();
    const timer = setInterval(fetchData, interval);
    return () => clearInterval(timer);
  }, [endpoint, interval]);

  return { data, loading };
};

// News endpoint - refresh every 5 minutes (news doesn't change that fast)
export const useNews = () => usePythonAPIData('/news', 300000);
